var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16009_2844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 10.618L3.37734 7.3725L0.131836 5.75L3.37734 4.1275L4.99984 0.882L6.62234 4.1275L9.86784 5.75L6.62234 7.3725L4.99984 10.618ZM2.36784 5.75L4.12234 6.6275L4.99984 8.382L5.87734 6.6275L7.63184 5.75L5.87734 4.8725L4.99984 3.118L4.12234 4.8725L2.36784 5.75ZM8.99984 10.5L9.74984 12L10.4998 10.5L11.9998 9.75L10.4998 9L9.74984 7.5L8.99984 9L7.49984 9.75L8.99984 10.5ZM9.66634 2.3335L10.2498 3.5L10.8333 2.3335L11.9998 1.75L10.8333 1.1665L10.2498 0L9.66634 1.1665L8.49984 1.75L9.66634 2.3335Z",
    fill: "url(#paint0_linear_16009_2844)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16009_2844",
    x1: 6.06584,
    y1: 0,
    x2: 6.06584,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B5F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16009_2844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.48dfc1ea1a91bcb45551408226a9494b.svg";
export { ForwardRef as ReactComponent };